<template>
  <div class="NeighborhoodStateAdvertisementList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="ruleForm.state">
            <el-option key :label="$t('lang.lab_AdverStatus')" :value="$t('lang.lab_NeighStatus')" ></el-option>
            <el-option v-for="item in NeighStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="ruleForm.type">
            <el-option key :label="$t('lang.lab_AdverType')" :value="$t('lang.lab_NeighType')" ></el-option>
            <el-option v-for="item in NeighType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="keyword" :placeholder="$t('lang.lab_AllRemitTitle')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>

      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jumpToAdd">{{$t('lang.lab_AdverAdd')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" :height="tableData.length > 0 ? require('@/config/enum').tableheight530 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.acheckbox"></el-table-column>
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="55px">
        </el-table-column>
        <el-table-column prop="id" :label="$t('lang.lab_AdverId')" width="150">
        </el-table-column>
        <el-table-column prop="orderBy" :label="$t('lang.lab_AdverSort')" width="150">
        </el-table-column>
        <el-table-column prop="type" :label="$t('lang.lab_AdverType')" width="230">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 304">{{NeighType[0].label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_AdverTitle')">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.name&&scope.row.name.length>10"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, 10) | valueIsNull }}
                <span v-if="scope.row.name.length>10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="state" :label="$t('lang.lab_AdverStatus')" width="230">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1">{{NeighStatus[0].label}}</span>
            <span v-if="scope.row.state === 2" class="red">{{NeighStatus[1].label}}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="endTime" :label="$t('lang.lab_AdverEndTime')" width="230">
          <template slot-scope="scope">
            {{ scope.row.endTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteItem(scope.row)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>
<script>
  /**
   *@ClassName:NeighborhoodStateAdvertisementList
   *@Description:邻里帮广告管理
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-04-03
   */
  import { mapGetters } from 'vuex'
  
  export default {
    name:'/manage/main.pivot3',
    data() {
      return {
        pageCount: 0, // 总数
        pageNum: 1, // 页数
        pageSize: 10, // 每页显示数量
        keyword: '', // 保存输入的查询词
        detail: this.$i18n.t('lang.ownerApp'),
        ruleForm: {
          state: '0', // 状态
          style: '0', // 平台
          targetUri: '', // 目标地址
          name: '', // 名称
          imageUri: '', // 图片地址
          fileList: [], // 文件列表
          type: '300', // 类型
          beginTs: Date.parse(new Date()), // 开始时间
          endTs: Date.parse(new Date()), // 结束时间
          orderBy: '1' // 排序
        },
        tableData: [], // 邻里帮广告管理列表数据
        acheckbox: require('@/config/enum').acheckbox, // 是否隐藏复选框
        deletename: require('@/config/enum').deletename,
        NeighStatus: this.$i18n.t('lang.NeighSelect.NeighStatus'), // 广告状态下拉列表
        NeighType: this.$i18n.t('lang.NeighSelect.NeighType'), // 广告类型下拉列表
      }
    },
    created() {
       setTimeout(() => {
         window.localStorage.setItem('llbform', '')
         window.localStorage.setItem('llbsaveData', '')
      }, 200)
      this.listShows()
    },
    activated(){
      this.listShows()
    },
    computed: {
      ...mapGetters({ village: 'gardenId' })
    },
    watch: {
      village: function (newFlag, oldFlag) {
        this.commit()
      }
    },
    methods: {
      // 删除方法
      deleteItem(row) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            this.$delete(`/ads/${row.id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 编辑方法
      edit(id) {
        window.localStorage.setItem('llbform', '')
         window.localStorage.setItem('llbsaveData', '')
        this.$router.push({
          name: 'NeighborhoodStateAdvertisementadd',
          query: { id: id }
        })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      },
      // 添加方法
      jumpToAdd() {
        window.localStorage.setItem('llbform', '')
         window.localStorage.setItem('llbsaveData', '')
        this.$router.push({
          name: 'NeighborhoodStateAdvertisementadd'
        })
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 页面列表展示方法
      listShows() {
        let loading = this.$loading()
        this.$get(`/ads?type=300&state=0&pageNo=1&pageSize=10&gardenid=${this.village}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      // 模糊查询方法
      topics() {
        let loading = this.$loading()
        this.$get(
          `/ads/?keyword=${this.keyword}&pageNo=${this.pageNum}&pageSize=${this.pageSize}&gardenid=${this.village}&${this.ruleForm.state ? 'state=' + this.ruleForm.state : 'state=0'}&${this.ruleForm.type ? 'type=' + this.ruleForm.type : 'type=300'}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询按钮
      commit() {
        this.pageNum = 1
        this.topics()
      },
    }
  }
</script>

<style lang="scss">

</style>